/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* =========================================================================
 * PageFly accordion fix
 * -------------------------------------------------------------------------
 * The PageFly app was removed from this store but its Liquid sections were
 * kept. PageFly's JavaScript is therefore gone, and every PageFly accordion
 * is dead: each answer panel is left with an inline style="display:none"
 * and nothing on the page ever removes it.
 *
 * Affected pages at the time of writing:
 *   - Custom Gold Foil DTF Gang Sheet ONLINE BUILDER   (section pf-dde1e14a)
 *   - Custom Gold Foil DTF Gang Sheet UPLOAD (Advanced) (section pf-3a7b6ddf)
 * Each has 10 FAQ questions whose answers could not be opened.
 *
 * This script restores the behaviour. It is generic: it will fix ANY PageFly
 * accordion anywhere on the site, so if more turn up later they just work.
 *
 * How PageFly's accordion markup is put together:
 *   <div data-pf-type="Accordion" data-multiple="false">        <- the group
 *     <div data-pf-type="Accordion.Content.Wrapper">            <- one item
 *       <button data-pf-type="Accordion.Header"
 *               data-header-id="UUID" data-active="false">      <- question
 *       <div data-pf-type="Accordion.Content"
 *            data-id="UUID" style="display:none">               <- answer
 *
 * The question and its answer are paired by that shared UUID. The theme's CSS
 * rotates the little arrow using [data-active="true"], so this script sets
 * that attribute as well as showing/hiding the panel.
 *
 * data-multiple="false" means only one answer stays open at a time, which is
 * how PageFly originally behaved. If a group is set to data-multiple="true",
 * this honours that too.
 *
 * Safe to run more than once. No jQuery, no external files.
 * ========================================================================= */
(function () {
  function initAccordion(root) {
    if (root.dataset.avAccordionReady === 'true') return;
    root.dataset.avAccordionReady = 'true';

    var allowMultiple = root.getAttribute('data-multiple') === 'true';
    var headers = root.querySelectorAll('[data-pf-type="Accordion.Header"]');
    if (!headers.length) return;

    function panelFor(header) {
      var id = header.getAttribute('data-header-id');
      if (!id) return null;
      var wrapper = header.closest('[data-pf-type="Accordion.Content.Wrapper"]') || root;
      return wrapper.querySelector('[data-pf-type="Accordion.Content"][data-id="' + id + '"]') ||
             root.querySelector('[data-pf-type="Accordion.Content"][data-id="' + id + '"]');
    }

    function setOpen(header, panel, open) {
      header.setAttribute('data-active', open ? 'true' : 'false');
      header.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.display = open ? 'block' : 'none';
    }

    Array.prototype.forEach.call(headers, function (header) {
      var panel = panelFor(header);
      if (!panel) return;

      header.setAttribute('aria-expanded', header.getAttribute('data-active') === 'true' ? 'true' : 'false');

      header.addEventListener('click', function (event) {
        // These buttons carry PageFly's "pf-anchor" class, which the theme's
        // own click handler also watches. Stop the event here so the theme
        // does not try to scroll to an anchor that does not exist.
        event.preventDefault();
        event.stopPropagation();

        var isOpen = header.getAttribute('data-active') === 'true';

        if (!allowMultiple) {
          Array.prototype.forEach.call(headers, function (other) {
            if (other === header) return;
            var otherPanel = panelFor(other);
            if (otherPanel) setOpen(other, otherPanel, false);
          });
        }

        setOpen(header, panel, !isOpen);
      });
    });
  }

  function initAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-pf-type="Accordion"]'),
      initAccordion
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-run if the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', initAll);
})();